module.exports = __webpack_public_path__ + "static/ogp-04141d6e57fabac2c00bcc16505f406b.png";